import { gql } from '../../../apollo/__generated__';

export const ROLES = gql(`
  query Roles {
    roles {
      name
    }
  }
`);
